import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0befdb37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visibleStatus !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'collab-status-banner alert mb-0 rounded-0 text-center py-2',
        _ctx.visibleStatus === 'authError' ? 'alert-danger' : 'alert-warning',
      ]),
          role: "alert",
          "aria-live": "assertive"
        }, [
          (_ctx.visibleStatus === 'authError')
            ? (_openBlock(), _createElementBlock("strong", _hoisted_1, " Your changes can't be saved. Please refresh the page to sign in again. "))
            : (_openBlock(), _createElementBlock("strong", _hoisted_2, " We're having trouble saving your changes. They'll be saved when the connection is restored — please don't close this tab. "))
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}